import { Component, Input, OnInit } from '@angular/core';
import { LMDimension } from '@modal/cubes/lm-cubes';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { LMCubeUtilService } from '@modal/cubes/lm-cube-util.service';
import { SohoAlertDirective } from 'ids-enterprise-ng';

@Component({
  selector:    'lm-cube-dimension-row',
  templateUrl: './lm-cube-dimension-row.component.html',
})

export class LMCubeDimensionRowComponent implements OnInit {
  @Input() cubeBusClass: string;
  @Input() dimension: LMDimension;
  @Input() structures: boolean;
  @Input() hasReportingBasis: boolean;
  @Input() topNodeBaseValue: string;

  public hasAlert: boolean;
  public get isState(): boolean {
    return this.dimension.type === 'state';
  }

  public get isBoolean(): boolean {
    return this.dimension.type === 'boolean';
  }

  public get isKeyField(): boolean {
    return this.dimension.type === 'keyfield';
  }

  public get isPeriod(): boolean {
    return this.dimension.type === 'period';
  }

  public get isText(): boolean {
    return this.dimension.type === 'simpletext';
  }

  public id: string;
  public selectListUrl: string;
  public getFieldsUrl: string;

  constructor(
    private lmCubeUtilService: LMCubeUtilService,
    private lmUniqueIdService: LMUniqueIdService,
  ) {}

  ngOnInit() {
    this.id = this.lmUniqueIdService.uniqueId(['cube-cell-dimension', this.dimension.type, this.dimension.name]);
    if (!this.dimension.value) {
      // The empty string does not come thru in JSON response from server.
      this.dimension.value = '';
    }
    if (this.isKeyField) {
      this.selectListUrl = this.lmCubeUtilService.getSelectListUrl(this.dimension);
      this.getFieldsUrl = this.lmCubeUtilService.getRequestUrl(this.cubeBusClass);
    }
    this.hasAlert = this.dimension.override || false;
  }

  public fieldValueChanged(event) {
    if (this.structures && this.hasReportingBasis) {
      this.hasAlert = true;
    }
  }
}
